//-- Copyright (c) 2021 TMT Insights Group, LLC
import styled from '@emotion/styled';
import { darken, lighten } from '@mui/material';
import { ReactNode } from 'react';

interface FileTypeSectionProps {
  title: string;
  count: number;
  color: string;
  children: ReactNode;
}

const DeliverableSection = ({ title, count, color, children }: FileTypeSectionProps) => {
  return (
    <Wrapper color={color}>
      <Header>
        <Title color={color}>{title}</Title>
        <Count>
          {count} file{count > 1 ? 's' : ''}
        </Count>
      </Header>
      <Content>{children}</Content>
    </Wrapper>
  );
};

export default DeliverableSection;

const Wrapper = styled.div<{ color: string }>`
  margin-bottom: ${({ theme }) => theme.spacing(2.5)};
  background: ${({ theme }) => (theme.palette.mode === 'dark' ? `rgb(255, 255, 255, 0.05)` : theme.palette.background.paper)};
  border: 1px solid ${({ color }) => color};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(1.5)};
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing(1)};
`;

const Title = styled.span<{ color: string }>`
  margin: 0px;
  color: ${({ color, theme }) => (theme.palette.mode === 'light' ? darken(color, 0.3) : lighten(color, 0.3))};
`;

const Count = styled.span``;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;
